import axios from 'axios';
import EventBus from "store/common/EventBus";
import Cookies from 'universal-cookie';
import { Notification } from 'components/common/Notification/Notification';
let cancelToken;

const cookies = new Cookies()

async function transformConfig(config) {
  const token = cookies.get('X-AUTH-TOKEN-ENC');
  const key = cookies.get('KEY-ENC');
  let authorization = {};
  if (config.isAuthorization) {
    authorization[`X-AUTH-TOKEN-ENC`] = token;
    authorization[`KEY-ENC`] = key;
    authorization[`INFO-TYPE`] = 1;
  }
  const headers = {
    'Content-Type': 'application/json;charset=utf-8',
    ...config.headers,
    ...authorization,
  };
  config.headers = headers;
  config.timeout = 60000;
  return config;
}


async function makeHttpRequest(apiCall) {
  try {
    const response = await apiCall();
    const responseData = response.data;

    if (responseData.errorCode === "100" || responseData.errorDescription === "Sai token") {

      cookies.remove('X-AUTH-TOKEN-ENC')
      cookies.remove('KEY-ENC')
      cookies.remove('KEY')
      EventBus.dispatch("logout");

      Notification.error(responseData.errorDescription);
      

    }
    return await responseData
  } catch (e) {
    if (e.response?.status === 401) {

      cookies.remove('X-AUTH-TOKEN-ENC')
      cookies.remove('KEY-ENC')
      cookies.remove('KEY')
      EventBus.dispatch("logout");

      Notification.error(`Xin lỗi, phiên đăng nhập của bạn đã hết hạn. Vui lòng đăng nhập lại để tiếp tục sử dụng.`);
      ;
    } else {
      return { error_code: "1", message: e.response?.data?.errorDescription ? e.response?.data?.errorDescription : "Có lỗi xảy ra" }
    }
  }

}

export async function postRequest(url, data, config = {}) {
  await transformConfig(config);
  if (cancelToken && config.cancel) {
    cancelToken.cancel('Operations cancelled due to new request');
  }
  if (config.cancel) {
    cancelToken = axios.CancelToken.source();
  }
  const custom = config.cancel ? { ...config, cancelToken: cancelToken.token } : config;
  delete custom.cancel;

  try {
    return makeHttpRequest(() => axios.post(url, data, config));
  } catch (error) {
    console.log('error', error?.response);
  }
}

export async function postFormRequest(url, data, config = {}) {
  await transformConfig(config);
  if (cancelToken && config.cancel) {
    cancelToken.cancel('Operations cancelled due to new request');
  }
  if (config.cancel) {
    cancelToken = axios.CancelToken.source();
  }
  const custom = config.cancel ? { ...config, cancelToken: cancelToken.token } : config;
  delete custom.cancel;

  try {
    return makeHttpRequest(() => axios.postForm(url, data, config));
  } catch (error) {
    console.log('error', error?.response);
  }
}

export async function getRequest(url, config = {}) {
  await transformConfig(config);
  if (cancelToken && config.cancel) {
    cancelToken.cancel('Operations cancelled due to new request');
  }
  if (config.cancel) {
    cancelToken = axios.CancelToken.source();
  }
  const custom = config.cancel ? { ...config, cancelToken: cancelToken.token } : config;
  delete custom.cancel;

  try {
    return makeHttpRequest(() => axios.get(url, config));
  } catch (error) {
    console.log('error', error?.response);
  }
}
